import { IXC_BILLING_V1_CHARGE_STATE_ENTITY_NAME } from '@interxfi/api-client/generated/entities/ixc-billing-v1-charge-state';
import { Pill, type PillProps } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type { IxcBillingV1ChargeStatus } from '@interxfi/types/generated/api';
import { getEntityVariant } from '../../../util/entity-status-variants';

interface BillingChargeStatusPillProps extends Omit<PillProps, 'children' | 'variant'> {
  status: IxcBillingV1ChargeStatus | undefined;
}

export function BillingChargeStatusPill({ isPending, status, ...props }: BillingChargeStatusPillProps) {
  return (
    <Pill isPending={!status || isPending} {...props} variant={getEntityVariant(IXC_BILLING_V1_CHARGE_STATE_ENTITY_NAME, status)}>
      <TranslatedText defaultValue={status} i18nKey={{ namespace: 'ixcBillingV1', enumName: 'IxcBillingV1ChargeStatus', value: status }} />
    </Pill>
  );
}
